export default __webpack_public_path__ + "static/background-v3@1x-f3aaf66f210e3bf6a747de9951036ba3.jpg";